<template>
  <div class="ayuda-container" data-app>
    <section class="doc-section ayuda-scope">
      <div class="container-fluid px-0">
        <h1 class="main-title">Instalación</h1>

        <plataformaNavegacion @cambio-plataforma="actualizarVista" />

        <div class="content-container mt-4">
          <v-fade-transition mode="out-in">
            <div :key="plataforma">

              <div v-if="plataforma === 'web'" class="platform-content">
                <h3>Requisitos previos</h3>
                <p>Para ingresar al panel de administración de la plataforma, haga clic en el siguiente enlace:</p>

                <a :href="urlWeb" class="link-aciqui">
                  <feather type="external-link" class="feather-xs mr-1"></feather>
                  ACIQUI
                </a>
              </div>

              <div v-if="plataforma === 'moviles'" class="platform-content">
                <h3>Instalación Android</h3>
                <p>A continuación, se detalla el procedimiento para la descarga e instalación de la aplicación
                  <strong>ACIQUI</strong> en dispositivos Android. Para completar el proceso, se deben ejecutar los
                  siguientes pasos:
                </p>


                <div class="contenedor-puntos-instalacion">

                  <ol class="ul-contenedor">
                    <li>
                      Ingresar al enlace de descarga:
                      <a :href="urlTienda" target="_blank" class="link-aciqui">
                        <feather type="external-link" class="feather-xs mr-1"></feather>
                        ACIQUI ANDROID
                      </a>
                    </li>
                    <li>
                      Dar click en el botón <strong>DESCARGAR PARA ANDROID</strong>
                      <CarruselAciqui :items="[misImagenesAndroid[0]]" />
                    </li>
                    <li>
                      La aplicación comenzará a descargarse.
                      <CarruselAciqui :items="[misImagenesAndroid[1]]" />
                    </li>
                    <li>
                      Una vez descargado dirigirse a <strong>Archivos > Descargas</strong> y seleccionar
                      <strong>Instalar</strong>.
                      <CarruselAciqui :items="misImagenesAndroid.slice(2, 4)" />
                    </li>
                    <li>Finalmente, abra nuevamente la aplicación e <strong>inicie sesión</strong> con sus credenciales
                      correspondientes.
                      <CarruselAciqui :items="misImagenesAndroid.slice(5, 8)" />
                    </li>
                  </ol>
                </div>

                <h2></h2>
                <h3>Instalación iOS</h3>
                <p>A continuación, se detalla el procedimiento para la descarga e instalación de la aplicación
                  <strong>ACIQUI</strong> en dispositivos iOS. Para completar el proceso, se deben ejecutar los
                  siguientes pasos:
                </p>


                <div class="contenedor-puntos-instalacion">
                  <ol class="ul-contenedor">
                    <li>
                      Ingrese al enlace de descarga:
                      <a :href="urlTienda" target="_blank" class="link-aciqui">
                        <feather type="external-link" class="feather-xs mr-1"></feather>
                        ACIQUI iOS
                      </a>
                    </li>
                    <li>
                      Dar click en el botón <strong>DESCARGAR PARA IOS.</strong>
                       <CarruselAciqui :items="[misImagenes[0]]" />
                    </li>
                    <li>
                      Dar clic en Instalar y la App comenzará a descargarse y se instalará automáticamente en la pantalla de inicio
                      del dispositivo.
                       <CarruselAciqui :items="misImagenes.slice(1,3)" />
                    </li>
                    <li>Una vez finalizada la descarga, seleccione el ícono de la aplicación para abrirla. Aparecerá el
                      mensaje <strong>“Desarrollador empresarial no confiable”</strong>; seleccionar
                      <strong>Cancelar</strong>.
                      <CarruselAciqui :items="[misImagenes[3]]" />
                    </li>
                    <li>Diríjase a <strong>Configuración > General > Administración de dispositivos y VPN</strong>.
                      Ingrese al apartado SECRETARIA DE MARINA-ARMADA DE MÉXICO y seleccione la opción
                      <strong>Confiar.</strong>
                      <CarruselAciqui :items="misImagenes.slice(4,8)" />
                    </li>
                    <li>Se mostrará una ventana solicitando permiso para ejecutar la aplicación empresarial. Seleccione
                      <strong>Permitir y reinicie</strong> el dispositivo si el sistema lo solicita.
                      <CarruselAciqui :items="[misImagenes[8]]" />
                    </li>
                    <li>Una vez completado el proceso, seleccione <strong>Instalar perfil</strong>, en caso de que se le
                      indique.
                       <CarruselAciqui :items="misImagenes.slice(9,12)" />
                    </li>
                    <li>Finalmente, abra nuevamente la aplicación e <strong>inicie sesión</strong> con sus credenciales
                      correspondientes.
                    <CarruselAciqui :items="[misImagenes[12]]" />
                    </li>
                  </ol>
                </div>


                <div class="info-grid">
                  <div class="info-card">
                    <h3>
                      <feather type="info" class="feather-icon"></feather> Información importante
                    </h3>
                    <p>
                      El mensaje “Desarrollador empresarial no confiable” es una medida de seguridad estándar de iOS
                      para aplicaciones distribuidas internamente fuera de la App Store.
                    </p>

                    <p>
                      Este procedimiento no representa un riesgo para el dispositivo, ya que la aplicación ha sido
                      desarrollada y firmada por SECRETARIA DE MARINA-ARMADA DE MÉXICO para uso interno.
                    </p>

                    <p>
                      El proceso descrito únicamente permite autorizar al sistema para ejecutar aplicaciones
                      empresariales confiables dentro de la organización.
                    </p>
                  </div>
                </div>

              </div>

            </div>
          </v-fade-transition>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import plataformaNavegacion from './BotonesNavegacion.vue';
import CarruselAciqui from './Carruselimg.vue';


const enlaceDescarga_01 = "img/instalacion_ios/IMG_0008.PNG";
const instalar_02 = "img/instalacion_ios/IMG_0009.PNG";
const descargando_03 = "img/instalacion_ios/IMG_0010.PNG";
const mensajeNoconfiable_04 = "img/instalacion_ios/IMG_0014.PNG";
const confGeneral_05 = "img/instalacion_ios/IMG_0015.PNG";
const admonVPN_05 = "img/instalacion_ios/IMG_0016.PNG";
const secretariaMarina_05 = "img/instalacion_ios/IMG_0017.PNG";
const confiarSecreMArina_05 = "img/instalacion_ios/IMG_0018.PNG";
const permitirReiniciar_06 = "img/instalacion_ios/IMG_0019.PNG";
const deslizarArribaPerfil = "img/instalacion_ios/IMG_7972.png";
const instalarPerfil = "img/instalacion_ios/IMG_7973.png";
const PerfilIntalado = "img/instalacion_ios/IMG_0020.PNG";
const iniciarSesion = "img/instalacion_ios/IMG_0021.PNG";

export default {
  components: { plataformaNavegacion, CarruselAciqui },
  data() {
    return {
      plataforma: 'web',
      urlWeb: process.env.VUE_APP_URL_LINK,
      urlTienda: `${process.env.VUE_APP_URL_LINK}/apps`,

      misImagenes: [
        {
          nombre: "",
          url: enlaceDescarga_01,
          descripcion: ""
        },
        {
          nombre: "Permitir instalar",
          url: instalar_02,
          descripcion: ""
        },
        {
          nombre: "Instalando App",
          url: descargando_03,
          descripcion: ""
        },
        {
          nombre: "",
          url: mensajeNoconfiable_04,
          descripcion: ""
        },
        {
          nombre: "Generales",
          url: confGeneral_05,
          descripcion: ""
        },
        {
          nombre: "Admón. de dispositivos y VPN",
          url: admonVPN_05,
          descripcion: ""
        },
        {
          nombre: "App empresarial",
          url: secretariaMarina_05,
          descripcion: ""
        },
        {
          nombre: "Confiar en Secretaria de Marina",
          url: confiarSecreMArina_05,
          descripcion: ""
        },
        {
          nombre: "",
          url: permitirReiniciar_06,
          descripcion: ""
        },
        {
          nombre: "Deslizar para instalar perfil de Marina",
          url: deslizarArribaPerfil,
          descripcion: ""
        },
        {
          nombre: "Instalar Perfil",
          url: instalarPerfil,
          descripcion: ""
        },
        {
          nombre: "Perfil de Marina Instalado",
          url: PerfilIntalado,
          descripcion: ""
        },
        {
          nombre: "",
          url: iniciarSesion,
          descripcion: ""
        },
      ],

      misImagenesAndroid: [
        {
          nombre: "",
          url: "img/instalacion_android/enlaceDescarga.jpg",
          descripcion: ""
        },
        {
          nombre: "",
          url: "img/instalacion_android/descargado.jpg",
          descripcion: ""
        },
        {
          nombre: "Descargas",
          url: "img/instalacion_android/Descargas.jpg",
          descripcion: ""
        },
        {
          nombre: "Intalar App",
          url: "img/instalacion_android/instalarApp.jpg",
          descripcion: ""
        },
        {
          nombre: "Intalando App",
          url: "img/instalacion_android/instalando.jpg",
          descripcion: ""
        },
        {
          nombre: "App ACIQUI Instalada",
          url: "img/instalacion_android/appInstalada.jpg",
          descripcion: ""
        },
        {
          nombre: "Aplicaciones",
          url: "img/instalacion_android/app.jpg",
          descripcion: ""
        },
        {
          nombre: "Inicio de sesión",
          url: "img/instalacion_android/login.jpg",
          descripcion: ""
        },
      ],

    };
  },
  methods: {
    actualizarVista(val) {
      this.plataforma = val;
    }
  }
}
</script>

<style scoped>
.main-title {
  font-family: 'Lexend', sans-serif;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: var(--text-color);
}

.platform-content h3 {
  font-size: 1.25rem;
  margin-top: 1rem;
  color: var(--primary-color);
}

.code-block {
  background: #1e1e1e;
  color: #d4d4d4;
  border-radius: 12px;
  margin: 1rem 0;
  overflow: hidden;
  border: 1px solid #333;
}

.code-header {
  background: #2d2d2d;
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.copy-btn {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid #444;
  color: #fff;
  padding: 4px 10px;
  border-radius: 6px;
  transition: all 0.2s;
}

.copy-btn:hover {
  background: var(--primary-color);
  border-color: var(--primary-color);
}

pre {
  padding: 1.2rem;
  margin: 0;
  overflow-x: auto;
  font-size: 0.9rem;
  line-height: 1.5;
  /* Scrollbar personalizado para móviles */
}

pre::-webkit-scrollbar {
  height: 4px;
}

pre::-webkit-scrollbar-thumb {
  background: #444;
  border-radius: 10px;
}

.custom-list {
  padding-left: 1.2rem;
  color: var(--text-color);
}

.feather-xs {
  width: 12px;
  height: 12px;
  vertical-align: middle;
}


/* Estilo del enlace personalizado */
.link-aciqui {
  display: inline-flex;
  align-items: center;
  color: var(--primary-color) !important;
  /* Usa tu color azul de ACIQUI */
  font-weight: 600;
  text-decoration: none;
  padding: 4px 12px;
  background-color: rgba(var(--primary-rgb), 0.1);
  /* Un fondo suave si tienes la variable RGB */
  border-radius: 6px;
  transition: all 0.3s ease;
  border-bottom: 1px dashed var(--primary-color);
}

.link-aciqui:hover {
  background-color: var(--primary-color);
  color: white !important;
  text-decoration: none;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Ajuste para el icono dentro del link */
.link-aciqui .feather-xs {
  stroke-width: 3px;
  margin-right: 5px;
}


.contenedor-puntos-instalacion {
  margin-top: 24px;

}

.contenedor-puntos-instalacion ol {
  padding: 0 24px;
}

.info-card {
  text-align: justify !important;
}

/* Ajustes responsivos */
@media (max-width: 768px) {
  .platform-content h3 {
    font-size: 1.1rem;
  }

  pre {
    font-size: 0.8rem;
    padding: 1rem;
  }

  .main-title {
    font-size: 1.75rem;
    text-align: center;
  }
}
</style>